import React, { createContext, useContext, useEffect, useReducer } from "react";
import { StylesProvider, jssPreset, ThemeProvider } from "@material-ui/styles";
import { MuiThemeProvider } from "@material-ui/core/styles";

import { create } from "jss";
import { createMuiTheme } from "@material-ui/core/styles";
import indigo from "@material-ui/core/colors/indigo";
import red from "@material-ui/core/colors/red";
import rtl from "jss-rtl";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const Context = createContext();
const { Provider } = Context;

const reducer = (state, action) => {
  switch (action.type) {
    case "direction":
      const newState = {
        ...state,
        direction: state.direction === "ltr" ? "rtl" : "ltr",
      };
      return newState;
    case "type":
      return { ...state, type: state.type === "light" ? "dark" : "light" };
    default:
      return state;
  }
};

const AppProvider = ({ children }) => {
  const prefersDarkMode = useMediaQuery("@media (prefers-color-scheme: dark)");
  const [state, dispatch] = useReducer(reducer, {
    type: prefersDarkMode ? "dark" : "light",
    direction: "ltr",
  });

  const theme = createMuiTheme({
    direction: state.direction,
    palette: {
      type: state.type,
      /*
      primary: {
        light: "#ba8641",
        main: "#ba8641",
        dark: "#ba8641",
        contrastText: "#ffffff", //getContrastText(palette.primary[500]),
      },
      */
      //primary: deepPurple, //#ba8641
      primary: indigo,
      secondary: {
        main: "#b71c1c",
      },
      error: red,
      background: {
        paper: "#fff",
        default: "#eaeef3", // ""
      },
    },
    typography: {
      headline: {
        fontSize: "1rem",
      },
      subtitle1: {
        fontSize: "0.8125rem",
      },
      button: {
        textTransform: "initial",
        fontWeight: 400,
      },
      body1: {
        fontSize: "0.875rem",
      },
    },
    spacing: 4,
    shape: {
      borderRadius: 8,
    },
  });

  useEffect(() => {
    document.body.dir = state.direction;
  }, [state.direction]);

  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <StylesProvider jss={jss}>
          <Provider value={[state, dispatch]}>{children}</Provider>
        </StylesProvider>
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

export default AppProvider;
export const useAppState = () => useContext(Context);
